import {
  ListenerEvent,
  IncomingMessage,
  MessageHandler
} from '@carvana/merch-native';
import { useMemo } from 'react';
import { useRemoveFavorite } from '~/hooks/vdp/favorites';

type RemoveFavoriteMessage = IncomingMessage<
  ListenerEvent,
  {
    stockNumber: number;
    vehicleId: number;
  }
>;

function isRemoveFavoriteMessage(
  message: IncomingMessage<ListenerEvent, any>
): message is RemoveFavoriteMessage {
  return (
    message.event === ListenerEvent.RemoveFavorite &&
    message.payload.stockNumber != null &&
    message.payload.vehicleId != null
  );
}

export default function useRemoveFavoriteHandler(): MessageHandler<ListenerEvent> {
  const removeFavorite = useRemoveFavorite();

  return useMemo(
    () =>
      new MessageHandler(
        isRemoveFavoriteMessage,
        (message: RemoveFavoriteMessage) => {
          void removeFavorite(message.payload);
        }
      ),
    [removeFavorite]
  );
}
